import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

interface AccordionProps {
  title: string;
  count: number | string;
  isOpen?: boolean;
  onToggle?: () => void;
  className?: string;
  children: React.ReactNode;
}

export function Accordion({ title, count, isOpen: controlledOpen, onToggle, className, children }: AccordionProps) {
  const [internalOpen, setInternalOpen] = useState(false);
  const isOpen = controlledOpen ?? internalOpen;
  const toggle = onToggle ?? (() => setInternalOpen((prev) => !prev));

  return (
    <div className={`dt-accordion ${className || ""}`}>
      <button className="dt-accordion__header" onClick={toggle} type="button">
        <span>
          <FontAwesomeIcon
            icon={faChevronRight}
            className={`dt-accordion__chevron ${isOpen ? "dt-accordion__chevron--open" : ""}`}
          />
          {" "}{title}
          <span className="dt-accordion__badge">{count}</span>
        </span>
      </button>
      <div className={`dt-accordion__body-wrapper ${isOpen ? "dt-accordion__body-wrapper--open" : ""}`}>
        <div className="dt-accordion__body">
          {children}
        </div>
      </div>
    </div>
  );
}
